<template>
  <div class="row">

    <!-- 단원/목차 -->
    <div class="col-lg-4">
      <div class="card b">
        <div class="card-header bg-gray-lighter text-bold">단원</div>
          <table class="table table-striped table-bordered table-hover">
            <tbody>
            <tr v-show="data.list.length==0" class="text-center">
              <td>No matching records</td>
            </tr>
            <tr v-for="(item, index) in data.list" :key="index">
              <td :class="item.relAtrbDepth=='1'?'table-info':''" @click="search(item)">
                <em v-show="item.relAtrbDepth=='2'" class="fa fa-plus text-primary mr-2"></em>
                {{ item.relAtrbTitle }}</td>
            </tr>
            </tbody>
          </table>
      </div>
    </div>

    <!-- // 단원/목차 -->
    <div class="col-lg-4">
      <div class="card b">
        <div class="card-header bg-gray-lighter text-bold">차시</div>
          <table class="table table-striped table-bordered table-hover">
            <tbody>
            <tr v-show="data.subList.length==0" class="text-center">
              <td>No matching records</td>
            </tr>
            <tr v-for="(item, index) in data.subList" :key="index" @click="files(item)">
              <td>{{ item.relAtrbTitle }}</td>
            </tr>
            </tbody>
          </table>
      </div>
    </div>

    <!-- // 개체 -->
    <div class="col-lg-4">
      <div class="card b">
        <div class="card-header bg-gray-lighter text-bold">개체</div>
        <table class="table table-striped table-bordered table-hover">
          <tbody>
          <tr v-show="data.files.length==0" class="text-center">
            <td>No matching records</td>
          </tr>
          <tr v-for="(item, index) in data.files" :key="index">
            <td>
              <a :href="getPath(item) " target="_blank">{{ item.relAtrbTitle }}</a></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getTextbookAtrbRelInfoList} from "@/api/ext/TextbookAtrbRelInfoApi";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject,aws_cdn_path} from "@/utils/Constants";

export default {
  components: {},
  props: {
    bookId: '',
  },
  setup(props) {
    const _dataObject = _.cloneDeep(dataObject);
    _dataObject.subList = [];
    _dataObject.files = [];
    const data = reactive(_dataObject)
    data.aws_cdn_path = aws_cdn_path

    const loadData = async () => {
      // 단원
      if (props.bookId) {
        data.params.textbookId = props.bookId
        data.params.relAtrbTypeCd = '1001'  /*1001:단원,1002:차시,1003:코너, 1004:개체 */
        data.params.relAtrbDepth = 1;
        let result = await getTextbookAtrbRelInfoList(data.params);
        data.list = result.data;
      }
    }
    onMounted(loadData)

    return {
      data,
      ...actions(data),
      dataAction: new TableActionClass(data),
    }
  }
}
function actions() {
  var context = {};
  context["getTextbookAtrbRelInfoList"] = getTextbookAtrbRelInfoList;  // get list

  // 차시
  async function search(_item) {
    let _params = {
      relPrntsAtrbId: _item.relAtrbId,
      relAtrbTypeCd: '1002' // 차시
    }
    this.files(_item)
    let result = await getTextbookAtrbRelInfoList(_params);
    this.data.subList = result.data;
  }

  // 개체
  async function files(_item) {
    let _params = {
      relPrntsAtrbId: _item.relAtrbId,
      relAtrbTypeCd: '1004' // 개체
    }
    let result = await getTextbookAtrbRelInfoList(_params);
    this.data.files = result.data;
  }
  function getPath(_item){
    let _url = this.data.aws_cdn_path;
    if(_item.relContentsViewUrl){
      _url += _item.relContentsViewUrl
    }else{
      _url += _item.relContentsUrl
    }
    return _url;
  }

  return {search, files, getPath}
}



</script>